import request from '@/utils/request'

export function listSystemMessage(data) {
  return request({
    url: '/system/message/page',
    method: 'post',
    data
  })
}

export function getSystemMessageUnreadCount() {
  return request({
    url: '/system/message/unread/count',
    method: 'get'
  })
}

export function markSystemMessageRead(messageId) {
  return request({
    url: `/system/message/${messageId}/read`,
    method: 'put'
  })
}

export function markAllSystemMessageRead() {
  return request({
    url: '/system/message/readAll',
    method: 'put'
  })
}

export function completeSystemMessage(messageId) {
  return request({
    url: `/system/message/${messageId}/complete`,
    method: 'put'
  })
}
